import type { ReactNode } from "react";
import styles from "./BuilderPortalEmptyCTA.module.scss";

interface Props {
  children: ReactNode;
}

export default function BuilderPortalEmptyCTA({ children }: Props) {
  return <div className={styles.wrapper}>{children}</div>;
}
